import { getNelnetCredqualUrl, NELNET_SLUG } from 'utils/getNelnetCredqualUrl'

export const DIRECT_LENDER_LINKS = ['sallie-mae', 'cas']

/**
 * Resolves the CTA href for a student-loan rate-table row.
 * Nelnet (CredQual) goes direct via its own URL, sallie-mae/cas use the
 * redirect flow, everyone else uses the default credible-marketplace link.
 *
 * @param {Object} params
 * @param {string} params.slug
 * @param {string} params.partnerURL
 * @param {string} [params.theme]
 * @param {string} params.redirectUrl - Direct-lender redirect href.
 * @param {string} params.checkRatesHref - Default credible-marketplace href.
 * @returns {string}
 */
export function getLenderCtaHref({ slug, partnerURL, theme, redirectUrl, checkRatesHref }) {
  if (slug === NELNET_SLUG) {
    return getNelnetCredqualUrl({ pageUrl: partnerURL, theme })
  }

  if (DIRECT_LENDER_LINKS.includes(slug)) {
    return redirectUrl
  }

  return checkRatesHref
}

/**
 * Resolves the CTA subtext for a student-loan rate-table row.
 *
 * @param {string} slug
 * @returns {string}
 */
export function getLenderDisclaimerText(slug) {
  if (slug === NELNET_SLUG) return 'with Nelnet Bank'
  if (slug === 'sallie-mae') return 'from Sallie Mae'
  if (DIRECT_LENDER_LINKS.includes(slug)) return 'On lender site'
  return "on Credible's website"
}
